var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPotentRiskRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7501 5.66699C6.48841 5.66699 1.41675 10.7387 1.41675 17.0003C1.41675 23.262 6.48841 28.3337 12.7501 28.3337C19.0117 28.3337 24.0834 23.262 24.0834 17.0003C24.0834 10.7387 19.0117 5.66699 12.7501 5.66699ZM12.7501 25.5003C8.06091 25.5003 4.25008 21.6895 4.25008 17.0003C4.25008 12.3112 8.06091 8.50033 12.7501 8.50033C17.4392 8.50033 21.2501 12.3112 21.2501 17.0003C21.2501 21.6895 17.4392 25.5003 12.7501 25.5003ZM17.0001 14.8753H14.1667V21.9587H11.3334V14.8753H8.50008V12.7503H17.0001V14.8753ZM28.6876 5.31283L32.5834 7.08366L28.6876 8.85449L26.9167 12.7503L25.1459 8.85449L21.2501 7.08366L25.1459 5.31283L26.9167 1.41699L28.6876 5.31283ZM28.6876 25.1462L32.5834 26.917L28.6876 28.6878L26.9167 32.5837L25.1459 28.6878L21.2501 26.917L25.1459 25.1462L26.9167 21.2503L28.6876 25.1462Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotentRiskRating);
export default __webpack_public_path__ + "static/media/potentRiskRating.2636935cfec588681600d1c405425681.svg";
export { ForwardRef as ReactComponent };